import Box from "@mui/material/Box";
import ModalPanel from "./ModalPanel";
import Stack from "@mui/material/Stack";
import RequestButton from "../buttons/RequestButton";

const VideoModal = ({ video, active, setActive }) => {
  return (
    <ModalPanel active={active} setActive={setActive}>
      <video
        src={video?.src}
        width={video?.width > video?.height ? "100%" : "60%"}
        style={{ marginLeft: video?.width > video?.height ? "0%" : "20%" }}
        autoPlay
        muted
        controls
      ></video>
      <Stack mt={2} justifyContent={"end"} direction={"row"}>
        <Box>
          <RequestButton
            text="Close"
            onClick={() => setActive(false)}
            alt={true}
            small={true}
          />
        </Box>
      </Stack>
    </ModalPanel>
  );
};

export default VideoModal;
